var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page policy-statute"},[_c('Nav'),_c('v-container',{staticClass:"page-content mt-8 mb-8 px-4 "},[_c('router-view')],1),_c('CFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }